import _ from 'lodash';
export default {
  getProductsIdsInDefaultLists(state) {
    return state.defaultShoppingList
      ? state.defaultShoppingList.items.map(product => product.item.id)
      : [];
  },
  getProductsIdsInLists(state) {
    return _.uniq(
      _.flatMap(state.shoppingLists, list => list.items.map(product => product.item.id)),
    );
  },
};
